import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'

const whiteList = ['/login'];

router.beforeEach((to, from, next) => {
  NProgress.start();
  const { token, authList } = store.getters;
  const toPath = to.path;
  const toAuth = to.meta.auth;
  
  if(token){
    if(toPath === '/login'){
      next('/');
    }else{
      if(!toAuth || !authList || (authList && Array.isArray(authList) && authList.indexOf(toAuth) != -1))
        next();
      else
        next('/login');
    }
  }else{
    if(whiteList.indexOf(toPath) >= 0){
      next();
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => NProgress.done())



// WEBPACK FOOTER //
// ./src/permission.js